import { createRoute } from '@/utils/routing'

export const PAYMENT_LIST_ROUTE = 'payments'
export const PAYMENT_VIEW_ROUTE = 'payments-paymentId-general'
export const PAYMENT_OPERATION_LIST_ROUTE = 'payments-paymentId-operations'
export const PAYMENT_ACTIVITY_LIST_ROUTE = 'payments-paymentId-activity'
export const FEE_PAYMENT_CREATE_ROUTE = 'payments-create-fee'

export const TOPUP_PAYMENT_CREATE_ROUTE = 'payments-create-topup'
export const INTERNAL_PAYMENT_CREATE_ROUTE = 'payments-create-internal'
export const WITHDRAWAL_PAYMENT_CREATE_ROUTE = 'payments-create-withdrawal'
export const FOREX_PAYMENT_CREATE_ROUTE = 'payments-create-forex'

export const ON_HOLD_PAYMENT_LIST_ROUTE = 'payments-on-hold'
export const INTEGRATOR_ON_HOLD_PAYMENT_LIST_ROUTE = 'payments-on-hold-integrator'
export const UNASSIGNED_PAYMENT_LIST_ROUTE = 'payments-unassigned'
export const VERIFICATION_PAYMENT_LIST_ROUTE = 'payments-verification'
export const UNDEFINED_TOPUPS_LIST_ROUTE = 'payments-unidentified-topups'
export const NOT_SETTLED_PAYMENT_LIST_ROUTE = 'payments-not-settled'
export const PENDING_CANCELLATION_PAYMENT_LIST_ROUTE = 'payments-pending-cancellation'
export const PENDING_PAYMENT_LIST_ROUTE = 'payments-pending'
export const ERROR_PAYMENT_LIST_ROUTE = 'payments-errors'
export const POSTPONED_SWIFT_PAYMENT_LIST_ROUTE = 'payments-postponed-swift'

function createRouteWithPaymentId (name, paymentId, options) {
  if (paymentId != null) {
    return createRoute(name, {
      params: { ...options.params, paymentId },
      query: options.query
    })
  }
}

export function createPaymentListRoute (options = {}) {
  return createRoute(PAYMENT_LIST_ROUTE, options)
}

export function createPaymentViewRoute (paymentId, options = {}) {
  return createRouteWithPaymentId(PAYMENT_VIEW_ROUTE, paymentId, options)
}

export function createPaymentOperationListRoute (paymentId, options = {}) {
  return createRouteWithPaymentId(PAYMENT_OPERATION_LIST_ROUTE, paymentId, options)
}

export function createPaymentActivityListRoute (paymentId, options = {}) {
  return createRouteWithPaymentId(PAYMENT_ACTIVITY_LIST_ROUTE, paymentId, options)
}

export function createFeePaymentCreateRoute (options = {}) {
  return createRoute(FEE_PAYMENT_CREATE_ROUTE, options)
}

export function createTopupPaymentCreateRoute (options = {}) {
  return createRoute(TOPUP_PAYMENT_CREATE_ROUTE, options)
}

export function createInternalPaymentCreateRoute (options = {}) {
  return createRoute(INTERNAL_PAYMENT_CREATE_ROUTE, options)
}

export function createWithdrawalPaymentCreateRoute (options = {}) {
  return createRoute(WITHDRAWAL_PAYMENT_CREATE_ROUTE, options)
}

export function createForexPaymentCreateRoute (options = {}) {
  return createRoute(FOREX_PAYMENT_CREATE_ROUTE, options)
}

export function createOnHoldPaymentListRoute (options = {}) {
  return createRoute(ON_HOLD_PAYMENT_LIST_ROUTE, options)
}

export function createIntegratorOnHoldPaymentListRoute (options = {}) {
  return createRoute(INTEGRATOR_ON_HOLD_PAYMENT_LIST_ROUTE, options)
}

export function createUnassignedPaymentListRoute (options = {}) {
  return createRoute(UNASSIGNED_PAYMENT_LIST_ROUTE, options)
}

export function createVerificationPaymentListRoute (options = {}) {
  return createRoute(VERIFICATION_PAYMENT_LIST_ROUTE, options)
}

export function createUndefinedTopupListRoute (options = {}) {
  return createRoute(UNDEFINED_TOPUPS_LIST_ROUTE, options)
}

export function createNotSettledPaymentListRoute (options = {}) {
  return createRoute(NOT_SETTLED_PAYMENT_LIST_ROUTE, options)
}

export function createPendingCancellationPaymentListRoute (options = {}) {
  return createRoute(PENDING_CANCELLATION_PAYMENT_LIST_ROUTE, options)
}

export function createPendingPaymentListRoute (options = {}) {
  return createRoute(PENDING_PAYMENT_LIST_ROUTE, options)
}

export function createPostponedSwiftPaymentListRoute (options = {}) {
  return createRoute(POSTPONED_SWIFT_PAYMENT_LIST_ROUTE, options)
}

export function createErrorPaymentListRoute (options = {}) {
  return createRoute(ERROR_PAYMENT_LIST_ROUTE, options)
}
